(function() {

    function onTariffTableColourChange(listingTile, newColour) {
        const variations = listingTile.querySelectorAll('[data-listing-tile-variation]');

        let newlyActiveVariation = null;
        variations.forEach(function(elem) {
            if (elem.getAttribute('data-variation-color') === newColour) {
                newlyActiveVariation = elem;
            }
        });

        if (newlyActiveVariation) {
            variations.forEach(function(variation) {
                variation.classList.remove('active');
            });
            newlyActiveVariation.classList.add('active');
        }
    }

    function onTariffTableColourSwatchClick(event) {
        event.preventDefault();
        const link = this;
        const listingTile = link.closest('[data-listing-tile]');
        const newColour = link.getAttribute('data-variation-color');
        onTariffTableColourChange(listingTile, newColour);
    }

    function onTariffTableColourSelect(event) {
        event.preventDefault();
        const select = this;
        const listingTile = select.closest('[data-listing-tile]');
        const newColour = select.value;
        onTariffTableColourChange(listingTile, newColour);
        select.value = select.getAttribute('data-variation-color');
    }

    function onClickBuyNowOnRefurbishedProductInNonRefurbishedTariffTable(event) {
        const popup = document.getElementById('refurbishedConfirmationPopup');
        // Check if popup exists and is not visible (using Bootstrap modal classes)
        if (popup && !popup.classList.contains('in') && popup.style.display !== 'block') {
            event.preventDefault();
            const popupBuyNowButton = popup.querySelector('a.add-to-basket-btn');
            const originalBuyNowButton = event.currentTarget;

            // Remove existing click handler by cloning and replacing
            const newPopupBuyNowButton = popupBuyNowButton.cloneNode(true);
            popupBuyNowButton.parentNode.replaceChild(newPopupBuyNowButton, popupBuyNowButton);

            // Add new click handler
            newPopupBuyNowButton.addEventListener('click', function() {
                originalBuyNowButton.click();
            });

            // Trigger Bootstrap modal (still requires jQuery for Bootstrap 3 modals)
            if (typeof $ !== 'undefined') {
                $(popup).modal();
            }
        }
    }

    // Event delegation for refurbished product clicks
    document.addEventListener('click', function(event) {
        if (event.target.matches('[data-listing-tile] a[data-refurb]') ||
            event.target.closest('[data-listing-tile] a[data-refurb]')) {
            const target = event.target.matches('[data-listing-tile] a[data-refurb]')
                ? event.target
                : event.target.closest('[data-listing-tile] a[data-refurb]');
            onClickBuyNowOnRefurbishedProductInNonRefurbishedTariffTable.call(target, event);
        }
    });

    // Event delegation for color swatch clicks
    document.addEventListener('click', function(event) {
        if (event.target.matches('[data-listing-tile-variation] [data-listing-tile-color-list] a') ||
            event.target.closest('[data-listing-tile-variation] [data-listing-tile-color-list] a')) {
            const target = event.target.matches('[data-listing-tile-variation] [data-listing-tile-color-list] a')
                ? event.target
                : event.target.closest('[data-listing-tile-variation] [data-listing-tile-color-list] a');
            onTariffTableColourSwatchClick.call(target, event);
        }
    });

    // Event delegation for color select changes
    document.addEventListener('change', function(event) {
        if (event.target.matches('[data-listing-tile-variation] [data-listing-tile-color-select] select')) {
            onTariffTableColourSelect.call(event.target, event);
        }
    });

    document.addEventListener('DOMContentLoaded', function() {
        if (document.querySelector('.listing-tile-pdp')) {
            return;
        }

        const filterElement = document.querySelector('.desktop-asa-message');
        if (!filterElement) {
            return;
        }

        const filter = filterElement.parentElement.parentElement;
        const targetElement = document.querySelector('.tariff-container');

        if (!targetElement) {
            return;
        }

        const filterOffset = targetElement.offsetTop;

        window.addEventListener('scroll', function() {
            const scrollPosition = window.pageYOffset;
            const targetElementOffset = targetElement.offsetTop + targetElement.offsetHeight;

            const isBellowFilter = scrollPosition >= filterOffset;
            const isAboveTargetElement = scrollPosition < targetElementOffset;
            const isMediumScreen = window.innerWidth > 991;

            filter.classList.toggle('sticky-plp', isBellowFilter && isAboveTargetElement && isMediumScreen);
        });
    });
})();
